// eslint-disable-next-line import/no-unresolved
import 'vite/modulepreload-polyfill';

import { loadPosthog } from './load-posthog';
import { loadReactApp } from './load-react-app';
import { loadSentry } from './load-sentry';
import { routes } from './routes/optimizer-lite/routes';

// Ensure sentry is imported and initialized first
loadSentry();

loadPosthog();

loadReactApp(routes);
